'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var PeerId = require('peer-id');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

var basePacket = {
  success: true,
  time: 0,
  text: ''
};

function createPing(_ref) {
  var network = _ref.network;

  function ping(_x) {
    return _ping.apply(this, arguments);
  }

  function _ping() {
    _ping = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId) {
      var options,
          _yield$_awaitAsyncGen,
          libp2p,
          peer,
          storedPeer,
          id,
          remotePeer,
          packetCount,
          totalTime,
          i,
          time,
          average,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(network.use());

            case 3:
              _yield$_awaitAsyncGen = _context.sent;
              libp2p = _yield$_awaitAsyncGen.libp2p;
              options.count = options.count || 10;
              peer = PeerId__default["default"].createFromB58String(peerId);
              storedPeer = libp2p.peerStore.get(peer);
              id = storedPeer && storedPeer.id;

              if (id) {
                _context.next = 16;
                break;
              }

              _context.next = 12;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "Looking up peer ".concat(peerId)
              });

            case 12:
              _context.next = 14;
              return _awaitAsyncGenerator(libp2p.peerRouting.findPeer(peer));

            case 14:
              remotePeer = _context.sent;
              id = remotePeer && remotePeer.id;

            case 16:
              if (id) {
                _context.next = 18;
                break;
              }

              throw new Error('Peer was not found');

            case 18:
              _context.next = 20;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "PING ".concat(id.toB58String())
              });

            case 20:
              packetCount = 0;
              totalTime = 0;
              i = 0;

            case 23:
              if (!(i < options.count)) {
                _context.next = 41;
                break;
              }

              _context.prev = 24;
              _context.next = 27;
              return _awaitAsyncGenerator(libp2p.ping(id));

            case 27:
              time = _context.sent;
              totalTime += time;
              packetCount++;
              _context.next = 32;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                time: time
              });

            case 32:
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t0 = _context["catch"](24);
              _context.next = 38;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                success: false,
                text: _context.t0.toString()
              });

            case 38:
              i++;
              _context.next = 23;
              break;

            case 41:
              if (!packetCount) {
                _context.next = 45;
                break;
              }

              average = totalTime / packetCount;
              _context.next = 45;
              return _objectSpread(_objectSpread({}, basePacket), {}, {
                text: "Average latency: ".concat(average, "ms")
              });

            case 45:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[24, 34]]);
    }));
    return _ping.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(ping);
}

exports.createPing = createPing;